import React from 'react';
import HeroPage from './HeroPage';
import AboutPage from './AboutPage';
import HackathonPage from './HackathonPage';
import WorkshopPage from './WorkshopPage';
import SponsorsPage from './SponsorsPage';
import ContactPage from './ContactPage';

const LandingPage = () => {
    return (
        <>
            <div id="home">
                <HeroPage />
            </div>
            <div id="about">
                <AboutPage />
            </div>
            <div id="hackathon">
                <HackathonPage />
            </div>
            <div id="workshop">
                <WorkshopPage />
            </div>
            <div id="sponsors">
                <SponsorsPage />
            </div>
            <div id="contact">
                <ContactPage />
            </div>
        </>
    );
};

export default LandingPage;